import React from 'react';

const Spacer = ({ width = 0, height = 0 }) => {
  return <div style={{ width, height }} />;
};

export default Spacer;
export { Spacer };
